import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as crypto from "crypto-js";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import * as uuid from "uuid";
import { FocuslinkService } from "../services/focuslink.service";
import { LocalDataStoreService } from "../services/local-data-store.service";
import { MyfocusService } from "../services/myfocus.service";
import { UserService } from "../services/user.service";

@Injectable({
	providedIn: "root",
})
export class GlobalHttpInterceptor implements HttpInterceptor {
	constructor(
		private localstorage: LocalDataStoreService,
		private focuslink: FocuslinkService,
		private userService: UserService,
		private myfocus: MyfocusService
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		req = req.clone({ headers: req.headers.set("Cache-Control", "no-cache") });
		req = req.clone({ headers: req.headers.set("Pragma", "no-cache") });

		req = req.clone({
			headers: req.headers.set("Expires", "Sat, 01 Jan 2000 00:00:00 GMT"),
		});

		if (req.url.includes("focuslink.focuspos.com")) {
			if (this.userService?.userToken) {
				req = req.clone({ headers: req.headers.set("x-focuspos-usertoken", this.userService.userToken) });
			}

			req = req.clone({
				headers: req.headers.set("Authorization", this.flGenerateAuthHeader(req)),
			});
		}

		if (req.url.includes("api.fpos.io")) {
			req = req.clone({
				headers: req.headers.set("Authorization", this.flGenerateAuthHeader(req)),
			});
		}

		if (req.url.includes("focusposapi.azurewebsites.net")) {
		}

		if (req.url.includes("api.ipify.org")) {
			req = req.clone({ headers: req.headers.delete("Cache-Control") });
			req = req.clone({ headers: req.headers.delete("Pragma") });
			req = req.clone({ headers: req.headers.delete("Expires") });
		}

		if (req.url.includes("authorize.net")) {
			req = req.clone({ headers: req.headers.delete("Cache-Control") });
			req = req.clone({ headers: req.headers.delete("Pragma") });
			req = req.clone({ headers: req.headers.delete("Expires") });
		}

		return next.handle(req);
	}

	flGenerateAuthHeader(req: HttpRequest<any>) {
		const licenseKey = environment.licenseKey;
		const licenseSecret = "06fa2be0-7470-4080-a146-4b73d1052866";
		const prefix = "hmac";
		const timestamp = new Date().getTime(); // UTC time in milliseconds since the Unix epoch
		const nonce = uuid.v4();

		let url = req.url;
		url = url.replace("https://", "");
		url = url.split("?")[0];

		const sigRawData = `${licenseKey}:${req.method}:${url}:${timestamp}:${nonce}`;
		const signature = this.generateHash(sigRawData, licenseSecret);
		const header = `${prefix} ${licenseKey}:${signature}:${timestamp}:${nonce}`;

		return header;
	}

	generateHash(message: string, secret: string): string {
		const hash = crypto.HmacSHA256(message, secret);
		const b64Hash = crypto.enc.Base64.stringify(hash);
		return b64Hash;
	}

	myFocusHeaders(request: HttpRequest<any>) {
		const apiSecret = "H7WzjMknbdfxVpKeBArbaVnDJJvCtIxNbXvm1MXkVXA=";
		const focusDateTimeString = this.myfocus.app.moment().utc().format("ddd, DD MMM YYYY HH:mm:ss") + " GMT";
		const md5 = crypto.enc.Base64.stringify(crypto.MD5("" + request.body + ""));
		const signatureToSign = `${request.method}||${md5}||${request.headers.get("content-type")}||${focusDateTimeString}||${environment.myFocusAuthKey}||||${
			request.url
		}`;
		const signatureHash = crypto.HmacSHA256(signatureToSign, apiSecret);
		const signedSignature = crypto.enc.Base64.stringify(signatureHash);

		request.headers.append("x-focuspos-key", this.myfocus.hardwareKey.value);
		request.headers.append("x-focuspos-date", focusDateTimeString);
		request.headers.append("x-partner-key", environment.myFocusAuthKey);
		request.headers.append("x-Content-MD5", md5);
		request.headers.append("Authorization", `Partner ${signedSignature}`);
	}
}
